module.exports = __webpack_public_path__ + "static/media/MercBClass1@2x.46084fbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/monoshift/MercBClass1@2x.jpg
// module id = 67
// module chunks = 0